import { CSSProperties } from "react";

export const XOverlay = ({
  opacity = 0.3,
  style,
}: {
  opacity?: number;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: `rgba(0, 0, 0, ${opacity})`,
        ...style,
      }}
    ></div>
  );
};
